import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { GourmetNeedLoveFormInput } from '@/models/needLove';

export const postGourmetNLForm = async (data: GourmetNeedLoveFormInput) => {
  const response = await mutationExecute({
    variables: {
      data,
    },
    mutation: graphql(`
      mutation PostGourmetNLForm($data: GourmetNlFormInputType!) {
        postGourmetNLForm(data: $data)
      }
    `),
  });

  return response.data?.postGourmetNLForm ?? '';
};
